<template>
  <div class="map">

      <GmapMap
        :center="map.center"
        :zoom="map.zoom"
        :options="map.options"
        ref="map">
        <!-- TO_DO make selectedCity of current location -->
        <GmapMarker v-for="(marker, index) in shops"
                    :key="index"
                    :position="marker.latLng"
                    @click="displayShopInfo(marker)"
                    :icon="map.customIcon" />
        <GmapMarker :position='{ "lat": currentLatitutde, "lng": currentLongitude }'
                    :icon="map.curPosIcon" />
      </GmapMap>

      <!-- Map overlay TOP-->
      <div class="map-overlay">
        <div class="container">

          <div class="card">
            <div class="card__body">
              <div class="form-group form-group--select">
                <label for="city">Pasirinkite miestą</label>
                <select id="city" class="form-control" v-model="selectedCity">
                  <option v-for="(city, index) in cities" :value="city" :key="index">
                    {{ city }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Location button -->
          <div class="location-button-container">
            <button class="location_button btn btn--block" @click="locateMe">
              <span class="icon-location-cntainer">
                <app-icon href="icon-location"></app-icon>
              </span>
            </button>
          </div>

          <!-- Pop up label -->
          <div class="contact-box" v-if="isPopupVisible">

            <div class="contact-box__top">
              <div class="contact-box__label">Pavadinimas</div>
              <div class="contact-box__value">{{ selectedShop.title }}</div>

              <div class="contact-box__label">Darbo laikas</div>
              <div class="contact-box__value">{{ selectedShop.worktime }}</div>
            </div>
            <div class="contact-box__bottom">

              <div class="contact-box__icon">
                <app-icon href="icon-directions"></app-icon>
              </div>
              <div class="contact-box__label">Adresas</div>
              <div class="contact-box__value">{{ selectedShop.address }}</div>

              <div class="contact-box__icon">
                <app-icon href="icon-phone"></app-icon>
              </div>
              <div class="contact-box__label">Telefono nr.</div>
              <div class="contact-box__value">{{ selectedShop.phone }}</div>

              <hr>
              <div class="contact-box__close" @click="hideShopInfo">Uždaryti</div>
            </div>

          </div>

          <!-- Nearest shops -->
          <div class="contact-box" v-if="!isPopupVisible">
            <div class="card__body">
              <!-- <p v-if="nearestCity[0]">
                {{ nearestCity[0].city }}
              </p> -->

              <div v-if="errorStr">
                Sorry, but the following error
                occurred: {{errorStr}}
              </div>

              <div v-if="gettingLocation">
                <i>Getting your location...</i>
              </div>

              <!-- <div v-if="location">
                Your location data is
                <div class="latitude" @click="locationChange">
                {{ location.coords.latitude }}
                </div>, {{ location.coords.longitude}}
              </div> -->

              <v-collapse-group
                :onlyOneActive="true"
                ref="single_instance_group">

                <div class="shop"
                    v-for="(marker, index) in orderedShops"
                    :key="index">

                    <!-- Collapsable items -->
                    <v-collapse-wrapper
                      v-on:beforeToggle="my_custom_action(
                        $event, marker.latLng.lat, marker.latLng.lng
                      )"
                      ref="toggleSecond">

                      <!-- Collapse toggls -->
                      <div class="header" v-collapse-toggle v-show="!isShopInfoOpened">
                        <span class="icon_container">
                          <app-icon href="icon-narvesen"></app-icon>
                        </span>
                        <div class="shop_info">
                          <!-- <span class="id">{{ marker.id }}</span> -->

                          <!-- <span class="latlng">{{marker.latLng}}</span> -->
                          <span class="city">{{ marker.city }}</span>
                          <span class="delimeter">, </span>
                          <!-- <span class="title">{{ marker.title }}</span> -->
                          <span class="address">{{ marker.address }}</span>
                          <!-- <span class="worktime">{{ marker.worktime }}</span> -->

                        </div>
                        <span class="icon_container_side">
                           <span class="distance"><b>{{ marker.distance }}</b><i>km</i></span>
                          <app-icon href="icon-arrow"></app-icon>
                        </span>
                      </div>
                      <!-- Collapse content -->
                      <div class="my-content" v-collapse-content>
                        <div class="header">
                          <span class="icon_container">
                            <app-icon href="icon-narvesen"></app-icon>
                          </span>
                          <div class="shop_info">
                            <!-- <span class="id">{{ marker.id }}</span> -->

                            <!-- <span class="latlng">{{marker.latLng}}</span> -->
                            <span class="city">{{ marker.city }}</span>
                            <span class="delimeter">, </span>
                            <!-- <span class="title">{{ marker.title }}</span> -->
                            <span class="address">{{ marker.address }}</span>
                            <!-- <span class="worktime">{{ marker.worktime }}</span> -->

                          </div>
                          <span class="icon_container_side icon_container_side-inner">
                            <span class="distance"><b>{{ marker.distance }}</b><i>km</i></span>

                            <!-- Close all button -->
                            <button v-on:click="close_all_content" class="button-close">
                                <!-- type="button" class="menu__close" -->
                                <app-icon href="icon-close"></app-icon>
                            </button>

                              <!-- <app-icon href="icon-arrow"></app-icon> -->
                          </span>
                        </div>

                        <!-- This is hiddend content -->
                        <span class="shop_title">
                          <h3> Narvesen: {{ marker.title }} </h3>
                        </span>

                        <div class="contact-box__label">Darbo laikas:</div>
                        <div class="contact-box__value work-time">
                          {{ marker.worktime.replace(" Š", "\nŠ") }}
                        </div>

                        <div class="contact-box__icon">
                          <app-icon href="icon-directions"></app-icon>
                        </div>
                        <div class="contact-box__label">Adresas</div>
                        <div class="contact-box__value">{{ marker.address }}</div>

                        <div class="contact-box__icon">
                          <app-icon href="icon-phone"></app-icon>
                        </div>
                        <div class="contact-box__label">Telefono nr.</div>
                        <div class="contact-box__value">
                          <a :href="`tel:${marker.phone}`">{{ marker.phone }} </a>
                        </div>


                        <a class="btn btn--block btn--primary" :href="`https://maps.google.com/?q=${ marker.address},${ marker.city}`" target="_blank">
                          <a :href="`https://maps.apple.com/maps?q=${ marker.address },${ marker.city}`" target="_blank">
                            Kaip nuvykti?
                          </a>
                        </a>

                      </div>
                    </v-collapse-wrapper>
                    <!-- End Collapsable items -->
                </div>
              </v-collapse-group>
            </div>
          </div>

        </div>

      </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
/* global google */
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

import VueGeolocation from 'vue-browser-geolocation';
import VueCollapse from 'vue2-collapse';

// Loadash
const _ = require('lodash');

// icons:
const curPosIconUrl = require('../assets/images/map-marker-cur-loc.svg');
const customIconUrl = require('../assets/images/map-marker.svg');


Vue.use(VueCollapse);
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
  },
});

export default {
  name: 'Map',
  data() {
    return {
      map: {
        center: {
          lat: 54.686214,
          lng: 25.279736,
        },
        zoom: 12,
        options: {
          disableDefaultUI: true,
          clickableIcons: false,
        },
        customIcon: {
          url: customIconUrl,
        },
        curPosIcon: {
          url: curPosIconUrl,
        },
      },
      cities: null,
      shops: null,
      isPopupVisible: false,
      selectedCity: 'Vilnius',
      selectedShop: null,
      workingours: null,
      location: null,
      gettingLocation: true,
      errorStr: null,
      currentLatitutde: 56,
      currentLongitude: 23,
      GeoNearByDataSet: null,
      locationChange: [0, 0],
      NearestShops: [],
      NearestCity: [],
      isShopInfoOpened: false,
    };
  },
  created() {
    this.$http.get('shops')
      .then((response) => {
        this.cities = response.data.cities;
        this.shops = response.data.shops;
      });
  },
  methods: {
    CalculateDistance(lon1, lat1, lon2, lat2) {
      // Distance to show shops
      const MaximumDistance = 5;

      // Radius of the earth in km - used in caalculations
      const R = 6371;

      // Javascript functions in radians
      const dLat = this.toRad((lat2 - lat1));
      const dLon = this.toRad((lon2 - lon1));
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
              + Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2))
              * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      // Distance in km
      const d = R * c;

      // 5 kilometers distance
      if (d <= MaximumDistance) {
        // Round distance to 1 decimal place
        const DistanceToReturn = Math.round(d * 10) / 10;
        // Return rounded distance
        return DistanceToReturn;
      }
      // else
      return false;
    },
    toRad(number) {
      return number * Math.PI / 180;
    },
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'));
        }
        navigator.geolocation.getCurrentPosition((pos) => {
          resolve(pos);

          this.currentLatitutde = pos.coords.latitude;
          this.currentLongitude = pos.coords.longitude;
          // Set new location coordinates for shop nearby
          this.locationChange = [pos.coords.latitude, pos.coords.longitude];

          this.map.center.lat = pos.coords.latitude; // 54.686214;
          this.map.center.lng = pos.coords.longitude; // 25.279736;
          this.map.zoom = 12;

          this.CalculateDistance(pos.coords.longitude, pos.coords.latitude, 23.896230, 54.898155);
        }, (err) => {
          reject(err);
        });
      });
    },
    async ChangeCytiToCurrentLocation() {
      if (this.nearestCity['0']) {
        return this.nearestCity['0'].city;
      }
      // else
      return Promise.reject();
    },
    async locateMe() {
      this.gettingLocation = true;
      try {
        this.gettingLocation = false;
        this.location = await this.getLocation();
        this.selectedCity = await this.ChangeCytiToCurrentLocation();
      } catch (e) {
        this.gettingLocation = false;
        this.errorStr = e.message;
      }
    },
    displayShopInfo(marker) {
      this.isPopupVisible = true;
      this.selectedShop = marker;
    },
    hideShopInfo() {
      this.isPopupVisible = false;
      this.selectedShop = null;
    },
    my_custom_action: function (event, lat, lng) {
      // console.log(vm); // logs component object before closing itself
      // vm.hide();
      // console.log(lat, lng)
      this.map.center.lat = lat;
      this.map.center.lng = lng;
      this.isShopInfoOpened = true;
      this.map.zoom = 16;
    },
    close_all_content: function () {
      this.isShopInfoOpened = false;
      this.$refs.single_instance_group.closeAll(); // closes all elements
      this.map.zoom = 12;
    },
  },
  computed: {
    orderedShops: function ReturnOrderedShopsList() {
      return _.orderBy(this.NearestShops, 'distance').splice(0, 5);
    },
    nearestCity: function ReturnNearestCity() {
      const CurrentCity = _.orderBy(this.NearestShops, 'distance').splice(0, 1);
      return CurrentCity;
    },
  },
  watch: {
    // currentLatitutde(number) {
    //   // console.log('currentLatitutde number');
    //   // console.log(number);
    // },
    // currentLongitude(number) {
    //   // console.log('currentLongitude number');
    //   // console.log(number);
    // },
    locationChange() {
      // empty old location shops obj
      this.NearestShops = [];

      const { shops } = this;
      Object.keys(this.shops).forEach((marker) => {
        const MarkerLng = shops[marker].latLng.lng;
        const MarkerLat = shops[marker].latLng.lat;

        // parameters
        const params = [
          MarkerLng,
          MarkerLat,
          this.currentLongitude,
          this.currentLatitutde,
        ];

        // Retrieve nearby shops and create new object
        if (this.CalculateDistance(...params)) {
          const TmpObj = shops[marker];

          // distance of currently foreached shop:
          TmpObj.distance = this.CalculateDistance(...params);
          this.NearestShops.push(TmpObj);
          // this.NearestShops.push(this.CalculateDistance( Params ));
        }
      });
    },
    selectedCity(city) {
      const bounds = new google.maps.LatLngBounds();
      let markersTotal = 0;
      let lastMarker = null;

      const { shops } = this;
      Object.keys(this.shops).forEach((marker) => {
        if (shops[marker].city === city) {
          bounds.extend(shops[marker].latLng);
          markersTotal += 1;
          lastMarker = shops[marker];
        }
      });

      // jei kada nors API atiduos shops kaip masyvą
      /*
      this.shops.forEach((marker) => {
        if (marker.city === city) {
          bounds.extend(marker.latLng);
          markersTotal += 1;
          lastMarker = marker;
        }
      });
      */

      if (markersTotal > 1) {
        this.$refs.map.fitBounds(bounds);
      }
      if (markersTotal === 1) {
        this.map.center = lastMarker.latLng;
        this.map.zoom = 12;
      }
    },
  },
};
</script>

<style scoped>
  /* SHOPS START */
    .work-time{
      white-space: pre;
    }
    .shop .header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dbdbdb;
      margin-bottom: 0.5em;
    }
    .shop_info{
      display: flex;
      flex: 1 1 auto;
      flex-wrap: wrap;
      /* width: 100%;
      */
    }
    .shop .icon_container{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex-direction: row;
      width: 36px;
      height:36px;
      margin-right: 0.5em;
      flex: 0 0 auto;
    }
    .icon_container_side-inner{
      width: 86px;
      display: flex;
      justify-content: space-between;
    }
    .shop .icon_container_side{
      display: flex;
      align-items: center;
      /* width: 16px; */
      height:16px;
      margin-left: 0.5em;
      flex: 0 0 auto;
      min-width: 50px;
    }
    .shop svg.icon{
      width: 36px;
      height: 36px;
    }
    .distance{
      float: right;
    }
  /* SHOPS END */

  /* Collapsable content */
  .v-collapse-content{
    display: none;
  }
  .v-collapse-content-end{
    display: block;
  }
  /* END Collapsable content */

  /* Location button */
  .location-button-container{
    display: block;
    position: absolute;
    margin: 32vh auto 0 auto;
    width: 100%;
    min-height: 50px;
    z-index: 1;
    pointer-events:all;
    /* bottom: 50px; */
  }
  .location_button{
    width: 32px;
    height: 32px;
    position: absolute;
    right: calc(20px);
    z-index: 1000;
    color: rgb(9, 50, 102);
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(223, 182, 182, 0.2) 0px 2px 4px 2px;
    border-radius: 50%;
    padding: 8px;
    pointer-events:all;
  }
  /* END Location button */

  /* .card override */
  .card {
    margin: 0 20px;
    pointer-events: all;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-group--select label {
    position: absolute;
    font-size: 11px;
    margin: 5px 16px;
    pointer-events: none;
  }

  .form-group--select label + select {
    padding-top: 20px;
    padding-bottom: 12px;
  }

  .map_wrapper{
    position: absolute;
    top: 0px;
    display: block;
    width: 100%;
    height: 100%;
    min-height: 100vh;
  }
  .vue-map-container {
    position: fixed;
    top: 0px;
    right: 0;
    bottom: 64px;
    left: 0;
  }

  .map-overlay {
    /* background-image: linear-gradient(-180deg,
      rgba(255, 255, 255, 0.30) 29%,
      rgba(255, 255, 255, 0.00) 96%); */
    position: relative;
    top: 0;
    right: 0;
    left: 0;
    pointer-events: none;
  }

  .contact-box  {
    margin: 40vh 20px 80px 20px; /* bottom margin to solve small screens problem */
    pointer-events:all;
  }
  .button-close{
    display: block;
    position: relative;
    width: 36px;
    height: 36px;
    background: none;
    border: none;
  }
  .button-close svg{
    width: 16px!important;
  }

  /* Desktop */
  @media (min-width: 992px) {
    .location-button-container{
      top:20px;
      bottom: 50px;
      max-width: 350px;
      position: relative;
      margin: 0px;
    }
    .location_button{
       right: 0px;
    }
    .navbar{
      z-index: 5;
    }
    .map {
      position: relative;
      flex-grow: 1;
      min-height: 500px;
    }

    .vue-map-container {
      bottom: 0;
      position: absolute;
    }

    .map-overlay {
      background-image: none;
      margin-top: 120px;
      margin-bottom: 120px;
      pointer-events: none;
    }

    .card,
    .contact-box  {
      max-width: 350px;
      margin: 20px 0 0;
      pointer-events:all;
    }
  }
</style>
